import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ProgressBarIndicator } from 'secondstep-components'

export const Department = styled.span`
  padding: 0 1.25rem;
  white-space: nowrap;
  overflow: hidden;
`

export const Name = styled.span`
  padding: 0 1.25rem;
  white-space: nowrap;
  overflow: hidden;
`

export const Pathway = styled.span`
  padding: 0 1.25rem;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`

export const StyledProgressBarIndicator = styled(ProgressBarIndicator)`
  display: flex;
  flex: 1;
  padding-right: 0.5rem;

  [class*='Background'] {
    background-color: ${themeGet('colors.linkLight')};
    height: 0.75rem;
    margin-top: 0.125rem;
    max-width: 150px;
  }

  [class*='BodyCopy'] {
    padding: 0.1875rem 0 0 0.5rem;
  }

  [class*='IndicatorWrapper'] {
    height: 0.75rem;

    [class*='Indicator'] {
      background-color: ${themeGet('colors.hsPrimaryPink')};
      border-color: ${themeGet('colors.hsPrimaryPink')};
      height: 0.75rem;
    }
  }
`

export const TotalPracticesDone = styled.span`
  display: flex;
  padding: 0 1.25rem;

  @media screen and (max-width: 1245px) {
    [class*='StyledSortButton'] {
      flex: 1;
    }

    [class*='ProgressBarIndicator'] {
      display: none;
    }
  }
`

export const UserProgressRowWrapper = styled.button`
  display: grid;
  grid-template-columns: 1.4fr 1.4fr 0.75fr 0.75fr 0.75fr 0.75fr 1.3fr;
  padding: 1.4375rem 0 1.3125rem;
  background: ${themeGet('colors.paleGray')};
  border-radius: 10px;
  border: 2px solid ${themeGet('colors.transparent')};
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    cursor: pointer;
    border-color: ${themeGet('colors.beaconGray')};
    transition: all 0.2s ease;
  }

  @media screen and (max-width: 1245px) {
    grid-template-columns: 1.2fr 1fr 0.75fr 0.75fr 0.75fr 0.75fr 1fr;
  }

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`
